import { FC, useState } from 'react';
import GroupedDocsTable from 'components/table/documents/GroupedDocsTable';
import { getSubdomain } from 'utils/helpers/routing';
import InnerWrapper from '../InnerWrapper';

const Screen: FC = () => {
  const [customSelectableRowProps, setCustomSelectableRowProps] = useState<string[]>([]);
  const [multiActionActive, setMultiActionActive] = useState(false);
  const isOperator = getSubdomain() === 'operators';

  return (
    <InnerWrapper
      canMultiSign={isOperator}
      customSelectableProps={customSelectableRowProps}
      setCustomSelectableRowProps={setCustomSelectableRowProps}
      setMultiActionActive={setMultiActionActive}
    >
      <GroupedDocsTable
        entityName="documents-sent"
        entityEndpoint="document-holders"
        searchParams={{
          tab: 'sent',
        }}
        isSelectable
        useCustomSelectBtn
        customSelectableRowProps={customSelectableRowProps}
        disablePagination={multiActionActive}
      />
    </InnerWrapper>
  );
};

export default Screen;
